import { __assign } from "tslib";
import React from 'react';
import { conditionalClassList } from '@at/formatter-utils/lib/class-name-utils/class-name.util';
/** NOTE: Please check whether the SVG/icon you're looking for is available under `@at/design-system-icons` [ATDS Icons Storybook](https://app.design-system.preprod.k8.atcloud.io/?path=/docs/icons-all-icons) */
export var SVG = function (_a) {
    var svgContent = _a.svgContent, className = _a.className, additionalClass = _a.additionalClass, height = _a.height, width = _a.width, viewBox = _a.viewBox, title = _a.title, desc = _a.desc, attributes = _a.attributes;
    var classNameList = conditionalClassList('atds-svg', !!className && className, !!additionalClass && additionalClass);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", height: height, width: width, viewBox: viewBox, className: classNameList }, attributes),
        React.createElement("title", null, title),
        desc && React.createElement("desc", null, desc),
        svgContent));
};
